export default [
  {
    path: "/preview/:code",
    name: "preview",
    component: () => import(/* webpackChunckName: "Login" */ "@/views/public/PublicView")
  },
]